import * as ng from 'angular';

export class FormService {
    private formSubmitted: boolean;

    constructor() {
        this.formSubmitted = false;
    }

    tryMethod (errors: any, callback: Function, aditionalCondition: any) {
        aditionalCondition = typeof aditionalCondition !== 'undefined' ? aditionalCondition : true;
        if ($.isEmptyObject(errors) && aditionalCondition) {
            callback();
        } else {
            this.setErrorFieldsTouched(errors);
            this.formSubmitted = true;
            $(`[name='form']`).find('.ng-invalid:visible:first').focus();
        }
    }

    setErrorFieldsTouched(errors: any): void {
        ng.forEach(errors, (field) => {
            ng.forEach(field, (errorField) => {
                errorField.$setTouched();
            });
        });
    }

    isFormSubmitted(): boolean {
        return this.formSubmitted;
    }

    resetFormSubmitted(): void {
        this.formSubmitted = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/ui/form.service.ts